import styled from 'styled-components';

import { PiechartCircle } from '@components/piechart-circle';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type ProgressWidgetProps = {
  completedRatio: number;
  title: string;
};

export const ProgressWidget = ({ completedRatio, title }: ProgressWidgetProps) => {
  const { t } = useScopedTranslate(locale);
  const percentage = Math.ceil(completedRatio * 100);

  return (
    <Container>
      <Stack orientation="horizontal" space={2} align="center">
        <PiechartCircle
          size={2}
          sections={[
            { color: 'elementIndigo100', value: completedRatio },
            { color: 'purple90', value: 1 - completedRatio },
          ]}
        />
        <div>
          <Text text={title} color="white100" font="semibold14" />
          <Text text={t('completedRatio', { percentage })} color="purple40" font="regular12" />
        </div>
      </Stack>
    </Container>
  );
};

const Container = styled.div({
  backgroundColor: theme.color.purple100,
  borderRadius: pxToRem(8),
  padding: `${pxToRem(12)} ${pxToRem(16)}`,
  height: pxToRem(60),
  width: 'fit-content',
  border: `${pxToRem(1)} solid ${theme.color.border10}`,

  '&:hover': {
    backgroundColor: theme.color.purple200,
  },
});

const locale = {
  en: {
    completedRatio: '{percentage}% complete',
  },
};
